import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

@Component({
    selector: 'edit-menu-dialog',
    templateUrl: './edit-menu-dialog.component.html',
    styleUrls: ['./edit-menu-dialog.component.scss'],
    standalone: false
})

export class EditMenuDialogComponent {

  menu: Models.ContentGastronomyMenu;
  showOrderField = false;
  displayError = false;

  constructor(public dialogRef: MatDialogRef<EditMenuDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
    this.menu = new Models.ContentGastronomyMenu();
    if (this.data?.menu) {
      this.menu.populateFromJSON(this.data.menu);
    } else {
      this.menu.menuParts = [];
    }
    this.showOrderField = !!this.data?.showOrderField;
    this.translate.get('dynamicContent.gastro');
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    if (!this.menu.title?.length || this.menu.menuParts.length === 0) {
      return this.displayError = true;
    }
    this.dialogRef.close({ menu: this.menu });
  }

  addPart() {
    this.menu.menuParts.push('');
  }

  removePart(index) {
    this.menu.menuParts.splice(index, 1);
  }

  update(event, index) {
    this.menu.menuParts[index] = event.target.value.replace(/\n/gm, '<br>');
  }

  resize(event) {
    event.srcElement.style.height = event.srcElement.scrollHeight - 4 + 'px';
  }
}
